import { Spin, Tabs } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import {
  upperCase,
  groupByMultiple,
  COLLEGE_UUID,
  momentDate,
} from "../../utils";
import {
  _ListCourseSubjects,
  _ListOldQuestionPapers,
} from "../../models/subjectModel";
import PsContext from "../../context";

const LoadCourseWiseSubjectListWithSem = ({ item }) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [selectedType, setSelectedType] = useState([]);
  const [file, setFile] = useState();
  const [courseId, setCourseId] = useState();

  useEffect(() => {
    loadData();
    if (courseId || COLLEGE_UUID) loadFiles();
  }, []);

  const loadData = () => {
    setLoader(true);
    _ListCourseSubjects({
      course_level_id: item.course_level_id,
      college_uuid: item.college_uuid,
      dept_type: item.dept_type,
      course_uuid: item.course_uuid,
      academic_year: item.academic_year,
    }).then((res) => {
      if (res.status == "1") {
        let d = groupByMultiple(res.data, function (obj) {
          return [obj.semester];
        });
        setDataList(res.data);
        setDataView(d);
        if (d.length > 0) setSelectedType(d[0]);
      }
      setLoader(false);
      let s = groupByMultiple(res.data, function (obj) {
        return [obj.course_id];
      });
      setCourseId(s[0][0].course_id);
    });
  };

  const loadFiles = () => {
    setLoader(true);
    _ListOldQuestionPapers({
      course_id: courseId,
      //   college_uuid: COLLEGE_UUID,
    }).then((res) => {
      if (res.status == "1") {
        setFile(res.data);
      }
      setLoader(false);
    });
  };

  const loadInnerDatas = () => {
    return selectedType.map((item, i) => {
      return (
        <tr key={i} style={{ fontSize: "14px" }}>
          <td align="center">{i + 1}</td>
          <td>{item.subject_code}</td>
          <td>{item.subject_name}</td>
          <td align="center">{upperCase(item.subject_type)}</td>
          <td align="center">{getFile(item.subject_id)}</td>
        </tr>
      );
    });
  };

  const getTabList = () => {
    let rv = [];
    dataView.map((item, i) => {
      rv.push({
        key: item[0].semester,
        label: `Sem-${item[0].semester}`,
      });
    });
    return rv;
  };

  const handleSemChange = (key) => {
    let s = dataList.filter((item) => item.semester == key);
    setSelectedType(s);
  };

  const getFile = (subId) => {
    // Files
    if (file && subId) {
      let s = file.filter((item) => item.subject_id == subId);
      if (s.length > 1) {
        return (
          <>
            <Form.Control
              as="select"
              size="sm"
              className="form-select form-select-sm-custom fw-bold"
              onChange={(e) => window.open(e.target.value, "_blank")}
            >
              <option value=""></option>
              {s.map((item, i) => (
                <option key={i} value={item.files} style={{ fontSize: "11px" }}>
                  {momentDate(item.exam_mon_year, "MMM-YYYY")}
                </option>
              ))}
            </Form.Control>
          </>
        );
      }
      if (s.length == "1") {
        return (
          <a target="_blank" href={s[0].files}>
            <Button
              size="sm"
              className="p-0 px-1 border"
              variant="light"
              style={{ fontSize: "13px" }}
            >
              {s[0] ? momentDate(s[0].exam_mon_year, "MMM-YYYY") : "view"}
              <i
                class="fa-solid fa-eye ms-1"
                style={{
                  color: `${context.settingValue("web_site_header_textcolor")}`,
                }}
              ></i>
            </Button>
          </a>
        );
      }
    }
    return "";
  };

  return (
    <div style={{ minHeight: "40px" }} className=" mt-2">
      <Spin spinning={loader}>
        {dataList && dataList.length > 0 && (
          <div className="antd-tab-mb-0">
            <Row>
              <Col md={12}>
                <Tabs
                  items={getTabList()}
                  type="line"
                  onChange={(k) => handleSemChange(k)}
                />
              </Col>
            </Row>
          </div>
        )}
        <table
          width="99%"
          align="center"
          className="mt-2 table table-sm table-hover"
        >
          <tbody>
            <tr className="bg-light">
              <td width="50" align="center">
                S.No
              </td>
              <td>Course Code</td>
              <td>Course Name</td>
              <td align="center">Course Type</td>
              <td width="100" align="center">
                Files
              </td>
            </tr>
            {loadInnerDatas()}
          </tbody>
        </table>
      </Spin>
    </div>
  );
};
export default LoadCourseWiseSubjectListWithSem;
